__turbopack_context__.v({
  "bannerCta": "PincodeCtaBannerSection-module__XMv9gW__bannerCta",
  "content": "PincodeCtaBannerSection-module__XMv9gW__content",
  "locationLabel": "PincodeCtaBannerSection-module__XMv9gW__locationLabel",
  "title": "PincodeCtaBannerSection-module__XMv9gW__title",
});
